module.exports = __webpack_public_path__ + "static/img/4.5ce65c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/hsyj/4.png
// module id = H+5b
// module chunks = 1